'use client';

import React from 'react';
import { useEffectOnce } from 'app/libs/useEffectOnce';
import { useBuyerBrandStore } from 'app/store/brand';

export interface SiteConfigProviderProps {
    config: {
        plan: BuyerSidePlan | null;
        taxInfo: TaxInfoResponse['data'];
        brandMeta: Brand | null;
    };
}

export const SiteConfigProvider: React.FC<SiteConfigProviderProps> = (props) => {
    const { config } = props;

    const {
        plan: currentPlan,
        taxInfo: currentTaxInfo,
        brandMeta: currentBrandMeta,
        setTaxInfo,
        setBrandMeta,
        setPlan,
    } = useBuyerBrandStore();

    useEffectOnce(() => {
        if (config.taxInfo && !currentTaxInfo) {
            setTaxInfo(config.taxInfo);
        }

        if (config.brandMeta && !currentBrandMeta) {
            setBrandMeta(config.brandMeta);
        }

        if (config.plan && config.plan.plan_type && !currentPlan) {
            setPlan(config.plan.plan_type);
        }
    });

    return null;
};
